import * as React from 'react'

import { SortDirection, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  sortAttribute: string
  direction: SortDirection
  onSort: (attribute: string, sortDirection: SortDirection) => void
}

export default function Header({ direction, sortAttribute, onSort }: Props) {
  return (
    <Table.Head>
      <Table.Row>
        <Table.SortableHeadCell
          colSpan={6}
          attribute="name"
          sortAttribute={sortAttribute}
          sortDirection={direction}
          onSort={onSort}
        >
          {i18n.t('common.employee')}
        </Table.SortableHeadCell>
        <Table.SortableHeadCell
          colSpan={6}
          attribute="job_title"
          sortAttribute={sortAttribute}
          sortDirection={direction}
          onSort={onSort}
        >
          {i18n.t('competencies_v2.assessments.job_title')}
        </Table.SortableHeadCell>
      </Table.Row>
    </Table.Head>
  )
}
